import { connect } from "react-redux";
import PremierPricingTable from "../../components/PremierPricingTable/index.jsx";

const mapStateToProps = (state) => ({
  deliveryData: state.PremierPricingTable.deliveryData,
  countryData: state.CountrySelector.countryData,
  premierDeliveryPrices: state.PremierPageFrame.content.premierDeliveryPrices,
  selectedCountry: state.PremierSelectorOptions.selectedCountry,
});

export default connect(mapStateToProps)(PremierPricingTable);
